<div class="step active-{{ step }}">
  <div class="step__container">
    <div class="step__container__box">
      <span class="step-one"></span>
    </div>
    <div class="step__container__box">
      <span class="step-two"></span>
    </div>
    <div class="step__container__box">
      <span class="step-three"></span>
    </div>
  </div>
</div>
